import React, { forwardRef, useState, useImperativeHandle } from 'react';
import DaumPostcode from 'react-daum-postcode';
import styled from 'styled-components';

import TotalModalWrapper from '../Normal/TotalModalWrapper';
import { useLanguage } from '../../../Context/LanguageContext';

const AddressModal = forwardRef((props, ref) => {
  const { exitClick } = props;
  const { t } = useLanguage();

  const [name, setName] = useState();
  const [address, setAddress] = useState();
  const [zoneCode, setZoneCode] = useState();
  const [fullAddress, setFullAddress] = useState();
  const [isDaumPost, setIsDaumPost] = useState('false');
  const [postKey, setPostKey] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const width = 280;//595;
  const height = 450;
  // const width = '100%';
  // const height = '100%';

  function handleAddress(data) {
    let AllAddress = data.address;
    let extraAddress = '';
    let zoneCodes = data.zonecode;

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
      }
      AllAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
    }
    setFullAddress(AllAddress);
    setZoneCode(zoneCodes);
    exitClick(AllAddress);
  }

  useImperativeHandle(ref, () => ({
    setFullAddress: (AllAddress) => {
      setFullAddress(AllAddress);
    },
    setZoneCode: (setZoneCode) => {
      setZoneCode(setZoneCode);
    },
    getFullAddress: () => {
      return fullAddress;
    },
    setOpacity: (val) => {
      if (val === 1) {
        setIsVisible(true);
        setPostKey((k) => k + 1);
      } else {
        setIsVisible(false);
      }
    }
  }));

  if (!isVisible) return null;

  return (
    <TotalModalWrapper>
      <ModalWrapper width={width + 20} height={height + 32}>
        <TopBarWrapper width={width + 20}>
          <ExitButton onClick={() => exitClick()}>{t('memberDetail.close')}</ExitButton>
        </TopBarWrapper>
        <DoumPostcodeWrapper width={width} height={height}>
          <DaumPostcode
            key={postKey}
            onComplete={handleAddress}
            autoClose
            width={width}
            height={height} />
        </DoumPostcodeWrapper>
      </ModalWrapper>
    </TotalModalWrapper>
  )
})

export default AddressModal;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;

const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;

  width: ${props => props.width}px;

  background-color: #FF8B48;
`;

const ExitButton = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 16px;
  color: #FFFFFF;
  margin: 0 10px 0 0;

  &:hover {
    cursor: pointer;
  }
`;

const DoumPostcodeWrapper = styled.div`
  // border: 1px solid #33C8FF;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;
